import { isArray } from 'lodash';
import moment from 'moment';
import { isObject, objectMap, isIsoDate, isURL } from './utils';

export enum InferredType {
	Undefined = 'Undefined',
	Array = 'Array',
	Object = 'Object',
	String = 'String',
	Number = 'Number',
	Date = 'Date',
	URL = 'URL',
	Boolean = 'Boolean',
}

/**
 * Duck typing at its finest 🦆 🦆 🦢
 * Pass in a string (or strings) and get back a parsed value
 * supports strings, numbers, dates, and urls
 * TODO: export this from ./index.tsx
 * TODO: this function could maybe run faster
 * TODO: this would be unnecessary if the info was just included in SRS data...
 */
export function parseInferredType(
	thing?: string | string[] | Record<string, any>
): InferredTypeValue {
	if (thing == null || thing == '') { // should '' return undefined?
		return {
			type: InferredType.Undefined,
			value: undefined
		}
	}
	if (typeof thing === 'boolean') {
		return {
			type: InferredType.Boolean,
			value: thing
		}
	}
	if (isArray(thing)) {
		return {
			type: InferredType.Array,
			value: thing.map(aDeeperThing => parseInferredType(aDeeperThing))
		}
	}
	if (isObject(thing)) {
		return {
			type: InferredType.Object,
			value: objectMap(thing as Record<string, any>, (aDeeperThing) => parseInferredType(aDeeperThing))
		}
	}
	thing = thing as string; // the rest is string parsing
	if (isIsoDate(thing)) // SRS returns ISO formatted dates in a string
		return {
			type: InferredType.Date,
			value: moment.utc(thing) // new Date(thing)
		}
	if (isURL(thing))
		return {
			type: InferredType.URL,
			value: new URL(thing)
		}
	// if (isNumber(thing)) // disable number for now. It captures strings to frequently
	// 	return {
	// 		type: InferredType.Number,
	// 		value: parseFloat(preformatNumber(thing))
	// 	}
	else
		return {
			type: InferredType.String,
			value: thing
		}
}


export type InferredTypeValue = {
	type: InferredType.Undefined,
	value: undefined
} | {
	type: InferredType.Array,
	value: InferredTypeValue[]
} | {
	type: InferredType.Object,
	value: { [key: string]: InferredTypeValue }
} | {
	type: InferredType.String,
	value: string
} | {
	type: InferredType.Number,
	value: number
} | {
	type: InferredType.Date,
	value: moment.Moment // Date
} | {
	type: InferredType.URL,
	value: URL
} | {
	type: InferredType.Boolean,
	value: boolean
}

// export type InferrableValues = string | string[] | Record<string, InferrableValues> // darn

/** Try to use a custom React renderer for the specific property interface rather than using this */
export function flattenInferredTypeValueToString(
	inferredTypeValue: InferredTypeValue
	// baseRenderer?: JSX.Element // TODO?
): string {
	if (inferredTypeValue.type === InferredType.Array) {
		return inferredTypeValue.value
			.map(aDeeperInferredTypeValue => flattenInferredTypeValueToString(aDeeperInferredTypeValue))
			.join(`\n`)
	}
	if (inferredTypeValue.type === InferredType.Object) {
		let objToString = '';
		for (const key in inferredTypeValue.value) {
			if (Object.prototype.hasOwnProperty.call(inferredTypeValue.value, key)) {
				const aDeeperInferredTypeValue = inferredTypeValue.value[key];
				objToString += `${key}: ${flattenInferredTypeValueToString(aDeeperInferredTypeValue)}\n`
			}
		}
		return objToString
	}
	if (inferredTypeValue.type === InferredType.Undefined) {
		return '';
	} else {
		// TODO: baseRenderer(inferredTypeValue)
		return inferredTypeValue.value.toString();
	}
}
